/**
 * Canonical staleTime presets (perf plan §5.8). Every ad-hoc `staleTime:`
 * override in the codebase should read from here instead of hand-rolling a
 * numeric literal — three tiers cover every real access pattern we have:
 *
 * - `live`     — polled/status data (job progress, research-in-flight,
 *                in-flight run rows). Pairs with a `refetchInterval`; the
 *                short staleTime just means a stray remount/focus refetch
 *                doesn't serve minutes-old data while something is running.
 * - `standard` — the default for most reads. Matches the QueryClient's own
 *                default (`lib/queryClient.ts`), so most queries don't need
 *                an override at all. Mutations/run completion already
 *                invalidate the caches they affect, so there's little value
 *                in staleTimes shorter than this for ordinary entity reads.
 * - `stable`   — rosters + workspace/account metadata that rarely changes
 *                (workspace list, workspace membership, account users,
 *                the workspace record itself). Safe to cache longer because
 *                nothing on these surfaces silently drifts between visits.
 */
export const STALE = {
  live: 30_000,
  standard: 5 * 60_000,
  stable: 30 * 60_000,
} as const;
